// extracted by mini-css-extract-plugin
export default {"main":"LayoutStyle_main__KQomC"};